import React, {useState, useEffect} from "react";
import {connect} from "react-redux";
import axios from "axios";
import {serverLink} from "../../resources/url";
import {Link} from "react-router-dom";
import {useNavigate} from "react-router-dom";
import {
    setApplicationDetails,
    setApplicationRequirementDetails,
    setGeneralDetails, setJambRequirementDetails, setOLevelRequirementDetails,
} from "../../actions/actions";
import Sidebar from "../common/sidebar/sidebar";
import Header from "../common/header/header";
function UndergraduateDashboard(props) {
    const navigate = useNavigate();
    const [userData] = useState(props.applicationLogin);
    const [IsLoading, setIsLoading] = useState(false)
    const [requirementList, setrequirementList] = useState([]);
    const [subjectList, setSubjectList] = useState([]);
    const [olevelList, setOlevelLis] = useState([]);
    const [applicationDetail, setApplicationDetail] = useState({
        oLevel: [],
        jamb: [],
        post_secondary: [],
        guardian: [],
        document: [],
    });
    const getUGApplicationRequirementList = async () => {
        await axios
            .get(`${serverLink}application/ug/requirements/`)
            .then((response) => {
                props.setOnApplicationRequirement(response.data.data);
            })
            .catch((error) => {
                console.log("NETWORK ERROR", error);
            });
    };

    useEffect(() => {
        getUGApplicationRequirementList();
    }, []);

    useEffect(() => {
        async function applicationRequirementList() {
            try {
                const documentRes = await axios.get(`${serverLink}application/documents/uploads`);
                setrequirementList(documentRes.data);

                const subjectRes = await axios.get(`${serverLink}application/jamb/requiremnt/${props.applicationData.CourseCode}`);
                setSubjectList(subjectRes.data);
                props.setOnJambRequirement(subjectRes.data)

                const olevelRes = await axios.get(`${serverLink}application/olevel/requiremnt/${props.applicationData.CourseCode}`);
                setOlevelLis(olevelRes.data);
                props.setOnOLevelRequirement(olevelRes.data)
            } catch (error) {
                console.log(error);
            }
        }

        applicationRequirementList();
    }, []);


    useEffect(() => {
        async function allApplicationData() {
            axios
                .get(
                    `${serverLink}application/ug/application/data/${props.applicationData.EntryID}`
                )
                .then((response) => {
                    setApplicationDetail(response.data);
                    props.setOnGeneralDetails(response.data);
                    setIsLoading(false);
                })
                .catch((error) => {
                     console.log(error);
                });
        }
        allApplicationData();
    }, []);

    useEffect(() => {
        if (props.applicationLogin.length === 0)
            navigate("/login");
    }, [props.applicationLogin]);

    return (
        IsLoading ?
            <>Loading</>
            :
        <>
            <div className="main-wrapper">
                <Header/>
                <Sidebar/>
                <div className="page-wrapper">
                    <div className="content">

            <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                    <div className="my-auto mb-2">
                        <h3 className="page-title mb-1">Welcome, {`${userData.FirstName} ${userData.MiddleName} ${userData.Surname}`
                        }</h3>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <a href="">Dashboard</a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">Dashboard</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 d-flex">
                    <div className="row flex-fill">
                        <div className="col-md-6 d-flex">
                            <div className="flex-fill">
                                <div className="card flex-fill">
                                    <div className="card-header d-flex align-items-center justify-content-between">
                                        <h4 className="card-title">Instruction</h4>
                                    </div>
                                    <div className="card-body d-flex justify-content-center align-items-center">
                                            <div className="col-lg-12">
                                                <p>
                                                    <strong>
                                                        Note: You can start filling the application by clicking
                                                        {"  "}
                                                    </strong>
                                                    on{"  "}
                                                    <span style={{ color: "green" }}>
                                            Start Application
                                        </span>{" "}
                                                    button below
                                                </p>
                                                <p>
                                                    You can re-enter and complete your application(s) at any
                                                    time convenient to you. Please fill in the application
                                                    details using guidance on the screens, you will see ‘next’
                                                    and ‘previous’ buttons to help you navigate your way around.
                                                </p>
                                                <div className="row">
                                                    {/* Required Documents Column */}
                                                    <div className="col-md-6">
                                                        <h5>Required Documents to Upload</h5>
                                                        <ul className="list-unstyled mt-2">
                                                            {requirementList.map((requirement, index) => (
                                                                <li key={index} className="mb-2 ">{requirement.DocumentName}</li>
                                                            ))}
                                                        </ul>
                                                    </div>

                                                    {/* Required Subjects Column */}
                                                    <div className="col-md-6">
                                                        <h5>UTME subjects and minimum score required</h5>
                                                        <p className="">Note: For applicants applying with JAMB result only</p>
                                                        <ul className="list-unstyled">
                                                            {subjectList.map((subject, index) => (
                                                                <li key={index} className="mb-2">
                                                                    <span className="fw-bold">{subject.Subject || 'N/A'}</span> - {subject.Score}
                                                                </li>
                                                            ))}
                                                            <li className="mt-3 border-top pt-2 fw-bold">
                                                                Total Score - {subjectList.reduce((acc, curr) => acc + (parseInt(curr.Score) || 0), 0)}
                                                            </li>
                                                        </ul>
                                                    </div>

                                                </div>

                                                <div>
                                                    <h5>Olevel result and minimum grade required</h5>
                                                    <table className="table table-bordered mt-3">
                                                        <thead>
                                                        <tr>
                                                            <th>Subject</th>
                                                            <th>Minimum Grade</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {olevelList.map((subject, index) => (
                                                            <tr key={index}>
                                                                <td>{subject.Subject || 'N/A'}</td>
                                                                <td>{subject.Grade}</td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    </table>


                                                </div>

                                                <br/>
                                                <p>
                                                    Before you submit your application you can view your
                                                    application in the application summary page.
                                                </p>
                                                <p>
                                                    Before you submit your application you will be asked to
                                                    confirm by declaration that the data you are submitting is
                                                    correct.
                                                </p>

                                                <div className="col-lg-6 col-sm-6" style={{ float: "right" }}>
                                                    <Link to={"/undergraduate/admission-type"} className="btn btn-info w-100 mx-3">
                                                        Start Application
                                                    </Link>
                                                </div>
                                                <div className="col-lg-6 col-sm-6" style={{ float: "right" }}>
                                                    <Link to={"/application"} className="btn btn-dark w-100">
                                                        Go Back
                                                    </Link>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
             {/*row*/}
                    </div>
                </div>
                </div>
                        {/*<Footer/>*/}
                    </div>
                    </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        applicationLogin: state.loginDetails,
        applicationData: state.applicationDetails,
        applicant_data: state.generalDetails,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setOnApplicationDetails: (p) => {
            dispatch(setApplicationDetails(p));
        },
        setOnGeneralDetails: (p) => {
            dispatch(setGeneralDetails(p));
        },
        setOnApplicationRequirement: (p) => {
            dispatch(setApplicationRequirementDetails(p));
        },
        setOnJambRequirement: (p) => {
            dispatch(setJambRequirementDetails(p));
        },
        setOnOLevelRequirement: (p) => {
            dispatch(setOLevelRequirementDetails(p));
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(UndergraduateDashboard);
